<template>
  <div class="box">
<!--    <span class="zbdw">备案号：<a href="https://beian.miit.gov.cn/" target="_blank">赣ICP备2023006329号-4</a></span>-->
<!--    <span >联系我们：0797-400452142</span>-->
<!--    <br>-->
    <div >
      <span class="zbdw">主办单位：江西广电创意文化有限责任公司</span>
      <span class="zbdw">技术支持：江西极致求索数字科技有限公司</span>
      <span class="zbdw">备案号：<a href="https://beian.miit.gov.cn/#/Integrated/recordQuery" target="_blank">赣ICP备2023006329号-4</a></span>
      <span >联系我们：15870655766</span>
    </div>
  </div>

</template>

<script>
export default {
  name: "CopyRight"
}
</script>


<style scoped>
.box {
  border-top: solid 1px #e7e6e4;
  padding-top: 30px;
  margin-top: 30px;
  text-align: center;
  font-size: .875rem;
  line-height: 1.25rem;
  padding-bottom: 30px;
  color: rgb(148 163 184/var(1, 1));

  a {
    color: #333;
  }

  .cop {
    margin-top: 10px;
  }

  .zbdw{
    margin-right: 15px;
    border-right: solid 1px #E7E6E4;
    padding-right: 15px;
  }

}


</style>